// Fixtures
const basePath = '/assets/images/backgrounds/';

// ---
export const backgrounds = [
  // Stadium
  {
    name: 'Stadium 1',
    filePath: `${basePath}stadium/stadium-1.png`
  },
  {
    name: 'Stadium 2',
    filePath: `${basePath}stadium/stadium-2.jpg`
  },
  {
    name: 'Stadium 3',
    filePath: `${basePath}stadium/stadium-3.jpg`
  },
  {
    name: 'Stadium 4',
    filePath: `${basePath}stadium/stadium-4.png`
  },
  {
    name: 'Stadium 5',
    filePath: `${basePath}stadium/stadium-5.webp`
  },
];
